import React, { VFC } from 'react';
import classNames from 'classnames';
import SpinnerImage from '@root/html/template/default/assets/svg/spinner.svg';

export const Spinner: VFC<{ className?: string }> = ({ className }) => (
    <SpinnerImage className={classNames('spinner', className)} />
);
